<template>
  <div >
    <div class="bg">
      <div class="contenter">
        <div style="display: flex;justify-content: space-between;align-items: center">
          <div class="imgs">
            <img style="" src="../../static/img/zuo.png" width="554" height="580"/>
          </div>
          <div class="right_box">
            <div style="display: flex;justify-content: center;align-items: center">
              <div style="width: 460px;">
                <div style="color: #3F87EA;font-size: 24px;font-weight: 600;">欢迎登录</div>
                <div style="margin-top: 60px">

                  <el-form :rules="loginFormRules" ref="loginForm" :model="loginForm" label-position="right" label-width="auto" show-message>
                    <el-form-item   label="" prop="loginName">
                      <!--                  <el-col :span="22">-->
                      <el-input
                        style="margin-bottom: 30px"
                        placeholder="请输入您的账号"
                        type="text"
                        v-model="loginForm.loginName"
                        clearable>
                        <i slot="prefix" style="color: #3F87EA" class="el-input__icon el-icon-user-solid"></i>
                      </el-input>
                      <!--                  </el-col>-->
                    </el-form-item>
                    <el-form-item  label="" prop="loginPassword">
                      <!--                  <el-col :span="22">-->
                      <el-input
                        style="margin-bottom: 30px"
                        v-model="loginForm.loginPassword"
                        placeholder="请输入您的密码"
                        show-password
                      >
                        <i slot="prefix" style="color: #3F87EA" class="el-input__icon el-icon-s-goods"></i>
                      </el-input>

                      <!--                  </el-col>-->
                    </el-form-item>
                    <el-form-item  label="" prop="loginCode" class="pr">
                      <!--                  <el-col :span="22">-->
                      <el-input
                        style="margin-bottom: 30px;"
                        v-model="loginForm.loginCode"
                        placeholder="请输入验证码"
                        clearable>
                        <i slot="prefix" style="color: #3F87EA" class="el-input__icon el-icon-success"></i>
                      </el-input>

                      <!--                      <button @click="getCode(regForm)" class="code-btn" :disabled="!show">-->
                      <!--                        <span v-show="show">发送验证码</span>-->
                      <!--                        <span v-show="!show" class="count">{{count}} s</span>-->
                      <!--                      </button>-->
                      <div class="code-btn">
                        <img class="count" :src="photo" style="margin-left: -17px; margin-top: -2px;" width="120" height="40px">
                        <div  style="font-size: 12px;color: #3F87EA;    margin-top: -15px;" @click="changePhoto">
                          看不清，换一张
                        </div>
                      </div>
                      <!--                  </el-col>-->
                    </el-form-item>
                    <el-form-item>
                      <el-button class="btn" @click="loginSubmit('loginForm')"round>登录</el-button>
                    </el-form-item>
                  </el-form>
                </div>

              </div>

            </div>

          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
const TIME_COUNT = 60 // 倒计时的时间
import {
  getToken,
  getSession,
} from '@/utils/auth'
export default {
  name: "login",
  data() {
    return {
      photo:'',
      show: true,
      count: '',
      timer: null,
      loginForm: {
        loginName: '',
        loginPassword: '',
        loginCode:''
      },
      loginFormRules: {
        loginName: [
          {required: true, message: '账号不可为空', trigger: 'blur'}
        ],
        loginPassword: [
          {required: true, message: '密码不可为空', trigger: 'blur'}
        ],
        loginCode: [
          {required: true, message: '验证码不可为空', trigger: 'blur'}
        ],
      }

    }
  },
  created() {

    this.showPhoto()

  },
  mounted() {


  },
  methods: {
    /*获取验证码*/
    showPhoto(){
      this.$axios.get('/user/ImageVerification',{
        params: {},
        responseType:"blob",
        headers: {'X-Token': getToken()}
      }).then(res => {
        console.log('kankan',res.data)
        this.photo=window.URL.createObjectURL(res.data)
      });
    },
    /*看不清换一张*/
    changePhoto(){
      this.showPhoto()
    },

    loginSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        var data ={
          username:JSON.stringify(this.loginForm.loginName),
          passwordPlainText:this.loginForm.loginPassword,
          verifyCode:this.loginForm.loginCode
        }
        if (valid) {
          this.$axios.post('/user/login',data

          ).then(res => {
            this.$router.replace("/index");
          });

        } else {
          return false;
        }
      });
    },
    getCode (formData) {
      // 验证码倒计时
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>
.bg{
  background: url("../../static/img/bg.png");
  width:100%;
  height:100%;  /**宽高100%是为了图片铺满屏幕 */
  position: absolute;
}
.contenter{
  width: 73.6%;
  height: 75.1%;
  background: #FFFFFF;
  border-radius: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.imgs{
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F8F8F8;
  width: 50%;
  /*border: 1px solid red;*/
  height: 720px;

}
.right_box{
  /*border: 1px solid red;*/
  width: 50%;
  height: 500px;
}
.btn{
  width: 460px;
  height: 60px;
  background: linear-gradient(90deg, #3F87EA 0%, #4165E1 100%);
  border-radius: 30px;
  color: #FFF;
  font-size: 18px;
}
.pr {
  position: relative;
}
.code-btn {
  width: 100px;
  height: 34px;
  position: absolute;
  top: 3px;
  right: 5px;
  z-index: 222;
  color: #3F87EA;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 16px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue